export default {
  emptyCart: {
    en: 'You cart is empty',
  },
}
